<template>

  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu">
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;" @click="goHome()">
        <img  :src="logo"  style="float: left;width: 50px;height: 50px;margin-top: 5px;"/>
        <div style="background-color: transparent; color: white; height: 60px; display: flex;flex-direction: column;justify-content: start; padding-left: 10px;">
          <div class="BSD_TITLE">Global Change Risk Map Platform</div>
          <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view"   class="rt_bg" style="width: 100%;height: 500px;text-align: center; font-family: 'PingFangSC-Medium'">

      <img src="http://bunjs.aiside.top/img_logged.png" style="width: 50vw;z-index: 10;left: 4.8vw;position: absolute;"/>
      <div style="background-color: white;position: absolute;width: 50vw;right: 0px;top: 0px;z-index: 11;height: 100vh;"></div>

      <el-row  style="z-index: 100;
                      background-color: transparent;width: 44vw;margin-left: 28vw;
                      margin-top: 10vh; border-radius: 50px;
                      background-color: rgba(255,255,255,0.9);">
        <el-col :span=12 style="padding: 20px 0px;">
          <img src="../../assets/bnu/login_left.png" style="margin-top: 40px;">
          <p style="color: #324157;font-size: 14px;line-height: 20px; font-family:'PingFangSC-Regular'">
            Global Change Risk Map Platform <br/>
            of Population and Economic Systems
          </p>
        </el-col>

        <el-col :span=12 style="padding: 20px 40px;height: auto; background-color: white; box-shadow: 0 30px 40px 20px rgba(0,0,0,0.05);
          border-radius: 0 50px 50px 0;
          border-radius: 0px 50px 50px 0px;">

          <el-row style="background-color: transparent;">
            <p style="height: 30px;line-height: 30px;font-size: 20px; font-weight: bold; font-family: 'Microsoft YaHei'">Sign in</p>
          </el-row>

          <el-row style="margin-top: 10px;">
            <p style="text-align: left; color:  #128FDC;">Email</p>
          </el-row>
          <el-row style="margin-top: 0px;">
            <el-input placeholder="Email" v-model="loginData.mail"></el-input>
          </el-row>

          <el-row style="margin-top: 5px; color:  #128FDC;">
            <p style="text-align: left;">Password</p>
          </el-row>
          <el-row style="margin-top: 0px;">
            <el-input placeholder="Passwrod" v-model="loginData.password"  show-password></el-input>
          </el-row>

          <el-row style="margin-top: 30px;">
            <el-button type="primary" style="width: 100%; font-size: 17px;" @click="sigin">Login</el-button>
          </el-row>

          <el-row style="text-align:center;padding: 15px 0px;font-size: 14px;">
            <a href="/#/BNUMap/FindPassword" style="color: #006EAC; font-family: 'PingFangSC-Regular'" >Forgot Password?</a>
          </el-row>

          <el-divider></el-divider>

          <el-row style="text-align: center;padding: 15px 0px;font-size: 14px;">
            <a href="/#/BNUMap/Register" style="color:black;font-weight: bold; font-family: ' PingFangSC-Medium'">Don't have an account? <span style="color:  #006EAC;">Join</span></a>
          </el-row>

        </el-col>
      </el-row>
    </el-main>

  </el-container>
</template>

<script>

  import { api_bnu_login } from "@/api";
  import {Notify} from "vant";

  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  export default {
    name: "Login",
    data(){
      return {
        logo:bsd_logo,
        loginData:{
          mail:undefined,
          password:undefined
        }
      }
    },
    methods:{
      goHome(){
        this.$router.push({path:'/BNUMap/main/Introduction'})
      },
      /**
       *
       * */
      sigin(){
        if(this.loginData.mail==undefined || this.loginData.mail.length==0){
          this.$message({
            type: 'info',
            message: 'Please Enter Email Address'
          });
          return;
        }
        if(this.loginData.password==undefined || this.loginData.password.length==0){
          this.$message({
            type: 'info',
            message: 'Please Enter Password'
          });
          return;
        }
        console.log("user login && param = ",this.loginData);
        let _this = this;
        api_bnu_login(this.loginData).then(res=>{
          let resData = res.data;
          let userData = resData.data;
          this.$appStorage.storeUserData(userData);
          console.log("resData = ",resData);
          if(resData.code==200000){
            _this.goHome();
          }else
          {
            _this.$alert(resData.msg?resData.msg:"The account or password is incorrect, please re-enter！", 'Prompt', {
              confirmButtonText: 'OK',
              callback: action => {

              }
            });
          }
        }).catch(() => {
          Notify({ type: "danger", message: "请求失败" });
        });

      }
    },

    mounted() {
      document.getElementById("router_view").style.height = document.body.clientHeight - 60 +"px";
      document.getElementById("form_container").style.height = document.body.clientHeight - 60 - 20 +"px";
    }
  }
</script>




<style scoped lang="scss">
@import "BSDMap";

.BSD_TITLE{
  margin-top: 12px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}
.BSD_SUBTITLE{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
}

.rt_bg{
  background-image: linear-gradient(133deg, #042B64 0%, #040C21 53%, #06275F 87%, #451E49 100%);
}
.headerManu{
 cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/Login.vue